/**
 * WordPress dependencies
 */
import { useBlockProps } from "@wordpress/block-editor";
import { getExtraDOMAttributes } from "./utils";

export default function Save({ attributes }) {
  const { icon, position = "standard" } = attributes;

  const iconSize = icon?.size?.includes("px") ? icon?.size : icon?.size + "px";

  const blockProps = useBlockProps.save({
    style: {
      "--brandy-jump-to-section-icon-size": iconSize,
      position: position === "standard" ? "relative" : "fixed",
      top: position === "top-right" ? "50px" : undefined,
      right:
        position === "top-right" || position === "bottom-right"
          ? "30px"
          : undefined,
      bottom: position === "bottom-right" ? "50px" : undefined,
    },
    ...getExtraDOMAttributes(attributes),
  });

  const generateIconHtml = (icon) => {
    if (!icon?.name || !icon?.type) {
      return "";
    }

    const iconClass = `ph${icon.type !== "regular" ? "-" + icon.type : ""} ph-${
      icon.name
    }`;

    return `<i class="${iconClass}"></i>`;
  };

  return (
    <div {...blockProps}>
      <div
        className="brandy-jump-to-section-icon-content"
        style={{ color: "inherit", height: iconSize, width: iconSize }}
        dangerouslySetInnerHTML={{ __html: generateIconHtml(icon) }}
      />
    </div>
  );
}
